const formatCnpjCpf = (cnpjCpf) => {
  if (!cnpjCpf) return "";
  const documento = cnpjCpf.replace(/[^A-Za-z0-9]/g, "").toUpperCase();

  if (documento.length === 11) {
    return documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  if (documento.length === 14) {
    return documento.replace(
      /^([\dA-Z]{2})([\dA-Z]{3})([\dA-Z]{3})([\dA-Z]{4})(\d{2})/,
      "$1.$2.$3/$4-$5",
    );
  }

  return cnpjCpf;
};

export default formatCnpjCpf;
